import { z } from 'zod'

import { requiredString, semester, semesterAndYearStatus } from '@/utils/zod'

export const schoolYearSchema = z.object({
  id: requiredString(),
  name: requiredString(),
  status: semesterAndYearStatus,
  start_date: z.coerce.date(),
  end_date: z.coerce.date(),
  semesters: z.array(semester)
})

export const parseSemester = (semesterItem: z.infer<typeof semester>) => ({
  id: semesterItem.id,
  name: semesterItem.name,
  startDate: semesterItem.start_date,
  endDate: semesterItem.end_date,
  isActive: semesterItem.is_active,
  schoolYear: semesterItem.school_year,
  status: semesterItem.status
})
